export default [
    {
        path: '/wishes',
        name: 'wishes',
        component: () => import('@/views/wishes/AddWishesView.vue')
    },
    {
        path: '/wishes/support',
        name: 'wishesSupport',
        component: () => import('@/views/wishes/WishesSupportView.vue')
    }
]
